import React, { useCallback, useEffect, useState } from 'react';
import { useDispatch } from 'react-redux';
import { Button, Space } from 'antd';
import i18next from 'i18next';
import { useHistory, useParams } from 'react-router';
import Form, { useForm } from 'antd/lib/form/Form';

import { getUnownedCentresOfUser } from 'redux/unownedCentresOfUser/actions';
import { postCentresOfUser } from 'redux/centresOfUser/actions';

import { RestInputContext } from 'components/RestInput/RestInputContext';
import { FormAddMoreStyles } from 'containers/Users/styles';
import CentresAddMoreSelect from './CentresAddMoreSelect';
import CentreFilter from '../Form/CentreFilter';

const FormAddMoreCentres = () => {
  const [form] = useForm();

  const dispatch = useDispatch();

  const { push } = useHistory();

  const { id } = useParams();

  const [loading, setLoading] = useState(false);

  const retrieveList = useCallback(
    ({ filter = {}, isRefresh, keepFilter }) => {
      dispatch(
        getUnownedCentresOfUser({
          id,
          data: {
            orderBy: 'name',
            ...filter,
            filter: filter.filter,
          },
          options: {
            keepFilter,
            isRefresh,
          },
        }),
      );
    },
    [], // eslint-disable-line
  );

  useEffect(() => {
    retrieveList({
      filter: {
        limit: 10,
        offset: 0,
      },
      isRefresh: true,
    });
  }, []); // eslint-disable-line

  const onBack = () => {
    push(`/config/users/${id}/show`);
  };

  const onFinish = (values) => {
    setLoading(true);
    dispatch(postCentresOfUser({ id, data: values }))
      .then(({ payload }) => {
        setLoading(false);
        if (payload?.success) {
          onBack();
        }
      })
      .catch(() => {
        setLoading(false);
      });
  };

  return (
    <FormAddMoreStyles>
      <CentreFilter retrieveList={retrieveList} />
      <Form form={form} onFinish={onFinish}>
        <RestInputContext.Provider value={{ form, record: {} }}>
          <CentresAddMoreSelect retrieveList={retrieveList} />
        </RestInputContext.Provider>
        <div className="flex-center-end group-action-footer">
          <Space size={15}>
            <Button onClick={onBack}>{i18next.t('button.cancel')}</Button>
            <Button htmlType="submit" type="primary" loading={loading}>
              {i18next.t('button.save')}
            </Button>
          </Space>
        </div>
      </Form>
    </FormAddMoreStyles>
  );
};

export default FormAddMoreCentres;
